/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown>, value: NonNullable<unknown> }} Billing_Voucher_AppliedInputs */

const en_billing_voucher_applied = /** @type {(inputs: Billing_Voucher_AppliedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.code} applied — ${i?.value} off`)
};

const id_billing_voucher_applied = /** @type {(inputs: Billing_Voucher_AppliedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.code} dipakai — potongan ${i?.value}`)
};

/**
* | output |
* | --- |
* | "{code} applied — {value} off" |
*
* @param {Billing_Voucher_AppliedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_voucher_applied = /** @type {((inputs: Billing_Voucher_AppliedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Voucher_AppliedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_voucher_applied(inputs)
	return en_billing_voucher_applied(inputs)
});